"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameImageURL = void 0;
var getGameImageURL = function (id, source) {
    return "/api/games/images/".concat(id || '').concat(source ? "?source=".concat(source) : '');
};
exports.getGameImageURL = getGameImageURL;
